<div class="main">
    <ng-container *ngIf="!noFacilityAccess">
    <div class="header">
        <result-test-filters
            [facilities]="this?.currentEvaluation?.value?.facilities || []"
            [currentEvaluation]="this.currentEvaluation"
            [tokenDictionary]="this?.currentEvaluation?.value?.tokenDictionary || {}"
            (filtersData)="this.getFiltersData($event)"
            [readOnly]="isMagic && !isAdmin"
            [facilitiesReadOnly]="facilitiesReadOnly"
            [initialFilters]="isMagic ? magicPayload?.filters : null"
        ></result-test-filters>
        <button
            class="downloadButton" (click)="handleExport()"
            [disabled]="this.isPdfLoading.value || this.isPending"
        >
            <app-loader *ngIf="isPdfLoading.value"></app-loader>
            <span *ngIf="!isPdfLoading.value">Download pdf</span>
        </button>
    </div>
    <app-magic-link
            *ngIf="isAdmin"
            [evaluationId]="evaluationId"
            [baseUrl]="null"
    [secret]="'my-super-secret-please-change'"
    ></app-magic-link>
    <div class="diagramBody" id="pdf_container" *ngIf="this.evaluationId">
        <result-common-info [evaluationId]="this.evaluationId"></result-common-info>

        <mat-tab-group class="tabs" >
            <div *ngIf="isPending" class="pending-row">
                <mat-spinner diameter="56" class="spinner"/>
            </div>
            <div *ngIf="!isPending">
                <mat-tab *ngFor="let category of categories;" [label]="category?.title" >
                    <div class="customDiagramContainer">
                        <div *ngFor="let question of category?.graphDataAll; let i = index" class='customDiagram'>
                            <plotly-plot
                                    *ngIf="question?.type !== 'table'"
                                    [id]="'plot' + category?.id + i"
                                    [data]="getDataFromQuestionsDiagram(question)"
                                    [divId]="'plot' + category?.id + i"
                                    [layout]="question?.layout"
                                    [config]="plotlyConfiguration.config"
                                    [style]="{ width: '100%', height: '100%'}"
                            >
                            </plotly-plot>
                            <div  *ngIf="question?.type == 'table'" class="questionWithOpenAnswer">
                                <div [innerHTML]="question?.layout?.title?.text" class="openQuestionTitle"></div>
                                <table
                                        *ngIf="question?.dataSource?.length"
                                        mat-table
                                        [dataSource]="question?.dataSource"
                                        class="answersTable"
                                        id="generalResultsTableQuestion"
                                >
                                    <ng-container [matColumnDef]="column" *ngFor="let column of question?.displayedColumns">
                                        <th mat-header-cell *matHeaderCellDef class="firstColumn"> {{column}} </th>
                                        <td mat-cell *matCellDef="let element"> {{element[column]}} </td>
                                    </ng-container>

                                    <tr mat-header-row *matHeaderRowDef="question?.displayedColumns"></tr>
                                    <tr mat-row *matRowDef="let row; columns: question?.displayedColumns;"></tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </mat-tab>
            </div>


        </mat-tab-group>

    </div>
    <div class="generalResultsTable-plug" *ngIf="isPending">
        <mat-spinner diameter="56" class="spinner"/>
    </div>
    <button
            class="downloadButton exportExcelButton"
            (click)="exportTableToExcel()"
            [disabled]="this.isPdfLoading.value || this.isPending"
    >
        <app-loader *ngIf="isPdfLoading.value"></app-loader>
        <span *ngIf="!isPdfLoading.value">Nach Excel exportieren</span>
    </button>
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 generalResultsTable" id="generalResultsTable" *ngIf="!isPending">
        <ng-container [matColumnDef]="column" *ngFor="let column of displayedColumns; index as i">
            <th
                    mat-header-cell
                    *matHeaderCellDef
                [ngStyle]="{'max-width': '160px', 'width': '160px'}"
            > {{column}} </th>
            <td
                mat-cell
                *matCellDef="let element"
                [ngClass]="{'bold': this.checkCategoryByTitle(element[column])}"
                [ngStyle]="{'color': this.getCellColor(element[column], element['Gesamter Mittelwert'], i === 0 || i === displayedColumns.length - 1), 'max-width': '160px'}"
            >
                {{element[column]}}
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    </ng-container>
</div>